module.exports = __webpack_public_path__ + "static/media/upgrade-btn-right-arrow.05a66d4f.svg";